<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight task-square">
        <task-info demandType="1"></task-info>
        <div class="edit-area">
            <hint-real-name @getUserIdentity="getUserIdentity"></hint-real-name>
            <real-name-pop ref="realNamePop"></real-name-pop>
            <div class="header">
                <div class="header-title">视频投稿</div>
            </div>
            <!-- 视频内容可编辑区域[[ -->
            <div class="edit-content video-content">
                <!-- 视频内容可编辑区域[[ -->
                <div class="video-text-content">
                    <video-upload-ugc-btn ref="uploaderVideo" @delVideo="removeFile" @completed="uploadVideoCompleted"
                        @videoTime="getVideoTime">
                    </video-upload-ugc-btn>
                    <div class="title">
                        <input type="text" class="title-textarea" @focus="tips.title=false" rows="1" v-model="form.title"
                            maxlength="30" placeholder="请输入标题内容（30个字以内）">
                        <span class="wordsNum">{{form.title.length}}/30</span>

                        <!-- 7.5修改 -->
                        <!-- 错误提示 -->
                        <p class="error-prompt" v-show="tips.title">未输入标题</p>
                    </div>
                    <!-- 标签 -->
                    <div class="tag-block">
                        <div class="tag-group tag-group-lable">
                            <div class="tag" v-for="tag in tagList" :key="tag" v-show="tagList.length!=0">{{tag}}<i
                                    class="ico-writing ico-delete" @click="removeTag(tag)"></i></div>
                            <input type="text" placeholder="每个标签限8个字，最多9个标签，多个标签用空格 或 Enter隔开" class="input-tag"
                                autocomplete="off" @keyup.enter="addInputTag" @keydown.space="addInputTag"
                                @blur="addInputTag" v-model="inputTag">
                            <!-- 错误提示 -->
                            <p class="error-prompt" v-show="tips.show">{{tips.content}}</p>
                        </div>
                    </div>
                    <div class="title">
                        <input type="text" class="title-textarea" rows="1" v-model.number="form.duration"
                            maxlength="30" style="background: transparent;" :disabled="videoDisable"
                            placeholder="视频时长">
                        <span class="wordsNum">秒</span>

                    </div>

                    <div class="img-upload">
                        <tgl-image-cloud-upload style="display: inline-block" btnId='pic1' :minWidth="640"
                            :minHeight="360" :isCrop="true" :maxSize="6*1024*1024" ref="imgUpload" @completed="imageUploadCompleted"
                            @deletePic="deletePic">
                            <template #text>
                                <div class="upload-text">点击上传封面图片</div>
                            </template>
                        </tgl-image-cloud-upload>
                        <div class="upload-tips">
                            上传高清、无二维码、无黑边的封面图、将获得更多推荐机会
                            <br>
                            支持最小尺寸640*360，最大6MB，格式为jpg/png的图片
                        </div>
                        <!-- 7.5修改 -->
                        <!-- 错误提示 -->
                        <p class="error-prompt" v-show="tips.cover">未上传封面图片</p>
                    </div>
                    <div class="declaration">
                        <i class="ico" :class="form.isOrigin ? 'ico-checkbox-checked' : 'ico-checkbox'"
                            @click="form.isOrigin == 0 ? form.isOrigin=1 : form.isOrigin=0"></i>
                        <div class="declaration-text" @click="form.isOrigin == 0 ? form.isOrigin=1 : form.isOrigin=0">声明原创（获得更高收益与曝光）</div>
                        <i class="ico ico-question"></i>
                        <div class="g-tooltip declaration-tips">
                            <div class="g-tooltip-arrows-down"></div>
                            <div class="tooltip-content">
                                伪造原创声明，将损失您的信用分和收益哦
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视频内容可编辑区域]] -->
            <media-select demandType="1" ref="mediaSelect" :mediaInfo="mediaSelectInfo" @changeAuth="sendTitleCover"></media-select>

            <div class="footer-bar">
                <div class="footer-bar-btn">
                    <div class="g-bottom-btn btn-group">
                        <a class="button bg-btn" href="javascript:;" @click="save('submit')">提交</a>
                        <a class="button" @click="save('draft')">存草稿</a>
                        <a class="button" @click="preview">预览</a>
                        <a class="button" @click="back">返回</a>
                    </div>
                </div>
            </div>
        </div>
        <video-preview ref="videoPreview"></video-preview>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/contribute/task.scss';
</style>
<script>
import taskInfo from './_task_info';
import imgUpload from 'Components/v4/upload/imgUpload_v4';
import mediaSelect from './media_select.vue';
import videoUploadUgcBtn from 'Components/v4/upload/videoUploadUgcBtn';
import hintRealName from 'Components/v4/hint/real_name.vue';
import realNamePop from 'Components/v4/pop/real_name_pop.vue';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    TaskAddVideo, TaskDetail, ArticleDetail, TaskEditVideoDraft, ActivityDraftInfo
} from 'Services/getData';
export default {
    data() {
        return {
            form: {
                articleId: 0,
                missionId: 0,
                title: '',
                videoId: '',
                cover: '',
                isOrigin: 0,
                duration: '',
                mediaInfo: "",
                tags: '',
                draftId: 0
            },
            tips: {
                title: false,
                content: false,
                cover: false,
                show: false
            },
            coverUrl: '',
            task: {},
            videoUploader: {
                total: {
                    percent: 0
                }
            },
            videoFile: {
                name: ''
            },
            videoUploadResponse: {},
            isSubmit: true,
            userIdentityData: {
                tglVerify: {
                    code: ''
                },
                flowUser: {}
            },
            videoDisable: true,
            edit_times: 0,
            total_sec: Date.now(),

            mediaSelectInfo: [],
            tagList: [],
            inputTag: ''

        }
    },
    components: {
        imgUpload,
        hintRealName,
        realNamePop,
        taskInfo,
        mediaSelect,
        videoUploadUgcBtn,
        videoPreview
    },
    mounted() {
        this.form.missionId = this.getTaskId();
        this.getArticleId();
        this.getDetail();
        this.getArticle();
    },
    methods: {
        preview() {
            let data = Object.assign({}, this.form);
            data.articleTitle = data.title
            data.creator = data.creator = this.$store.state.realUserInfo.userName;
            data.created = `${new Date().toLocaleDateString()} ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`;
            data.summary = data.title;
            data.articleType = 1;
            this.$refs.videoPreview.contributeInfo(data);
        },
        sendTitleCover() {
            this.$refs.mediaSelect.getTitleCover(this.form.title, this.coverUrl);
        },
        getVideoTime(time) {
            if (!time) {
                this.videoDisable = false;
            } else {
                this.videoDisable = true;
            }
            this.form.duration = time;
        },
        showqqVerify() {
            this.$refs.realNamePop.showqqVerify = true;
        },
        showTglAndQqVerify() {
            this.$refs.realNamePop.showTglAndQqVerify = true;
        },
        async getUserIdentity(data) {
            this.userIdentityData = data;
            this.toShowUserIdentity();
        },
        getTaskId() {
            return this.$route.params.taskId;
        },
        getParams(selectMediaList, autoAuth) {
            this.form.mediaInfo = [];
            selectMediaList.forEach((v, k) => {
                console.log(this.form.mediaInfo)
                let mediaInfo = {};
                mediaInfo.accountId = v.curAccount.id;
                if (autoAuth) {
                    mediaInfo.title = '';
                    mediaInfo.cover = '';
                    mediaInfo.summary = '';
                } else {
                    mediaInfo.title = v.title;
                    mediaInfo.cover = v.cover;
                    mediaInfo.summary = v.summary;
                }
                this.form.mediaInfo.push(mediaInfo);
            })
            this.form.mediaInfo = JSON.stringify(this.form.mediaInfo);
        },
        getArticleId() {
            if (this.$route.query.type === 'draft') {
                this.form.draftId = this.$route.params.articleId
                return;
            }
            if (this.$route.params.articleId) {
                this.form.articleId = this.$route.params.articleId;
            }
        },
        toShowUserIdentity() {
            if (!this.userIdentityData.qqVerify) {
                this.showqqVerify();
                return false;
            }
            if (this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false) {
                this.showTglAndQqVerify();
                return false;
            }
            return true;
        },
        async save(type) {
            this.$refs.mediaSelect.saveDefaultMedia()
            this.edit_times++;
            if (!this.toShowUserIdentity()) {
                return false;
            }
            if (!this.form.missionId) {
                this.$alert("任务不存在");
                return false;
            }
            if (!this.form.title || this.form.title < 10) {
                this.tips.title = true;
                this.$alert('标题不能为空，不能少于10个字')
                return false;
            }
            if (!this.form.videoId) {
                this.$alert("请上传视频");
                return false;
            }
            if (!this.form.cover) {
                this.$alert('未上传封面图片')
                this.tips.cover = true;
                return false;
            }
            let {
                mediaInfo, autoAuth
            } = this.$refs.mediaSelect.getSelectMediaList();
            this.getParams(mediaInfo, autoAuth);
            if (this.$refs.mediaSelect.showPublish && this.form.mediaInfo.length <= 2) {
                this.$alert("请选择渠道");
                return false;
            }
            this.form.tags = this.tagList.join(',');
            if (!this.form.tags) {
                this.tips.show = true;
                this.tips.content = '标签不能为空';
                return false;
            }
            if (this.isSubmit) {
                let reqStartTime = Date.now();
                this.isSubmit = false;
                let res = null;
                // if (this.form.articleId == 0) {
                //     res = await TaskAddVideo(this.form);
                // } else {
                //     res = await TaskEditVideo(this.form);
                // }
                switch (type) {
                    case "submit":
                        res = await TaskAddVideo(this.form);
                        break;
                    case "draft":
                        res = await TaskEditVideoDraft(this.form);
                        break;
                }
                this.$common.reportContribute(
                    res.data.code == 0 ? 1 : 0,
                    res.data.info,
                    this.edit_times,
                    'task',
                    reqStartTime,
                    this.total_sec,
                );
                if (res.data.code == 0) {
                    this.$alert('操作成功');
                    // this.$router.push({name:'v4-manage-content',params:{tabId:3}});
                    if (type === 'submit') {
                        this.$router.push({
                            name: 'v4-task-detail', params: {
                                detailId: this.form.missionId
                            }
                        })
                    } else {
                        this.form.draftId = res.data.data
                    }
                }
                this.isSubmit = true;
            }
        },
        imageUploadCompleted(data) {
            this.form.cover = data.id;
            this.coverUrl = data.url;
        },
        deletePic() {
            this.form.cover = '';
            this.coverUrl = '';
        },
        async getDetail() {
            let res = await TaskDetail({
                missionId: this.form.missionId
            });
            if (res.data && res.data.code == 0) {
                this.task = res.data.data;
                if (this.task.id == undefined) {
                    this.$alert('任务不存在');
                } else if (this.task.mission_status != 30) {
                    this.$alert('任务已结束不能投稿');
                }
            }
        },
        uploadVideoProcess(uploader) {
            this.videoUploader = uploader.uploader;
        },
        uploadVideoCompleted(result) {
            this.form.videoId = result.videoId;
            this.form.qcloudFileId = result.qcloudFileId;
            // this.params.videoName = result.fileName;
        },
        removeFile(file) {
            this.form.videoId = 0;
            this.$refs.uploaderVideo.fileName = '';
        },
        back() {
            this.$confirm('返回内容将不被保存，确认返回？').then(() => {
                this.$router.go(-1);
            }).catch((e) => {
            });
        },
        async getArticle() {
            if (this.form.draftId) {
                let ret = await ActivityDraftInfo({
                    draftId: this.form.draftId
                });
                if (ret.status == 200 && ret.data.code == 0) {
                    let article = ret.data.data;
                    this.form.isOrigin = article.isOriginal;
                    this.form.videoId = article.videoId;
                    this.$refs.uploaderVideo.videoId = article.videoId;
                    this.$refs.uploaderVideo.completed(article.qcloudFileId);
                    this.$refs.uploaderVideo.progressBar = 100;
                    this.$refs.uploaderVideo.fileName = article.videoName;
                    this.videoFile.name = article.videoName;
                    this.form.title = article.articleTitle;
                    this.form.cover = article.attachments.id;
                    this.form.duration = article.duration;
                    this.$refs.imgUpload.setPic(article.attachments.attachmentUrl);
                    this.mediaSelectInfo = article.mediaDistribute;
                    this.coverUrl = article.attachments.attachmentUrl;
                    this.form.qcloudFileId = article.qcloudFileId;
                    if (article.tags.length) {
                        this.tagList = article.tags;
                    }
                    if (!this.mediaSelectInfo.length) {
                        this.$refs.mediaSelect.getDefaultMedia()
                    }
                }
                return;
            }

            if (this.form.articleId) {
                let ret = await ArticleDetail(this.form.articleId);
                if (ret.status == 200 && ret.data.code == 0) {
                    let article = ret.data.data;
                    this.form.isOrigin = article.isOriginal;
                    this.form.videoId = article.videoId;
                    this.$refs.uploaderVideo.videoId = article.videoId;
                    this.$refs.uploaderVideo.completed(article.qcloudFileId);
                    this.$refs.uploaderVideo.progressBar = 100;
                    this.$refs.uploaderVideo.fileName = article.videoName;
                    this.videoFile.name = article.videoName;
                    this.form.title = article.articleTitle;
                    this.form.cover = article.attachments[0].id;
                    this.form.duration = article.hourLong;
                    this.$refs.imgUpload.setPic(article.attachments[0].attachmentUrl);
                    this.mediaSelectInfo = article.mediaDistribute;
                    this.coverUrl = article.attachments[0].attachmentUrl;
                    this.form.qcloudFileId = article.qcloudFileId;
                    if (article.tags.tags) {
                        this.tagList = article.tags.tags.split(',');
                    }
                    if (!this.mediaSelectInfo.length) {
                        this.$refs.mediaSelect.getDefaultMedia()
                    }
                }
                return;
            }
            this.$refs.mediaSelect.getDefaultMedia()
        },
        addInputTag() {
            let sTag = this.inputTag.replace(/^\s+|\s+$/g, "");
            if (sTag && sTag.length > 8) {
                this.tips = {
                    content: '单个标签不能超过8个字符哦~',
                    show: true
                }
                this.inputTag = '';
                return false;
            }
            if (this.tagList.includes(sTag)) {
                this.tips = {
                    content: '存在重复的标签哦~',
                    show: true
                }
                this.inputTag = '';
                return false;
            }
            if (sTag) {

                if (this.tagList.length > 8) {
                    this.tips = {
                        content: '最多输入9个标签哦~',
                        show: true
                    }
                } else {
                    this.tagList.push(sTag);
                    this.tips.show = false;
                }
            }
            this.inputTag = '';
        },
        removeTag(tag) {
            let index = this.tagList.indexOf(tag);
            this.tagList.splice(index, 1);
            this.tips.show = false;
        }
    }
}
</script>